var map = {
	"./app-android.svg": 5065,
	"./app-apple.svg": 7725,
	"./arrow-right.svg": 8900,
	"./arrow-up.svg": 5362,
	"./award.png": 9928,
	"./camera-front-color.png": 8526,
	"./case-1.jpg": 3609,
	"./case-2.jpg": 4160,
	"./case-3.png": 5504,
	"./case-4.png": 7965,
	"./case-5.png": 2765,
	"./chevron.svg": 974,
	"./clients/belbet.svg": 3509,
	"./clients/betboom.png": 2836,
	"./clients/betcity.svg": 4265,
	"./clients/delimobil.svg": 6855,
	"./clients/dozarplati.png": 4302,
	"./clients/favorit.png": 2028,
	"./clients/fonbet.png": 5106,
	"./clients/ivi.png": 7519,
	"./clients/leon.png": 8128,
	"./clients/liga_stavok.png": 6210,
	"./clients/litres.png": 5770,
	"./clients/magnit.svg": 3153,
	"./clients/mostbet.svg": 1678,
	"./clients/okko.svg": 6988,
	"./clients/paribet.png": 2516,
	"./clients/perekrestok.svg": 6594,
	"./clients/sber_market.png": 3607,
	"./clients/sber_megamarket.png": 6547,
	"./clients/sberzvyk.svg": 3067,
	"./clients/stoloto.png": 2214,
	"./clients/tinkoff.svg": 280,
	"./clients/vkysvill.png": 3427,
	"./clients/winline.png": 9273,
	"./clients/ytkonos.svg": 8239,
	"./clients/zaimer.png": 5782,
	"./close.svg": 5289,
	"./figma-front-color.png": 9533,
	"./gb.svg": 6467,
	"./header-cases.png": 5902,
	"./header-home.png": 2782,
	"./header-services.png": 3471,
	"./header-solutions.png": 9807,
	"./logo.svg": 5522,
	"./main-pic-1.png": 6692,
	"./main-pic-2.png": 5605,
	"./main_pic_1-en.png": 6451,
	"./main_pic_2-en.png": 640,
	"./menu.svg": 2898,
	"./notes.png": 4587,
	"./robot.png": 4966,
	"./ru.svg": 177,
	"./source-logo-baidu.svg": 5711,
	"./source-logo-crossinstall.png": 4677,
	"./source-logo-crossinstall.webp": 8853,
	"./source-logo-digitalturbine.png": 6139,
	"./source-logo-digitalturbine.webp": 5333,
	"./source-logo-facebook.svg": 5764,
	"./source-logo-googleads.svg": 1700,
	"./source-logo-mintegral.png": 1488,
	"./source-logo-mopub.svg": 5490,
	"./source-logo-searchads.svg": 3206,
	"./source-logo-snapchat.svg": 3273,
	"./source-logo-taboola.svg": 2855,
	"./source-logo-twitter.svg": 8568,
	"./source-logo-unity.svg": 6583,
	"./source-logo-vungle.png": 7339,
	"./sources-logo-adcolony.png": 7495,
	"./sources-logo-applovin.png": 2960,
	"./sources-logo-bigoads.png": 9142,
	"./sources-logo-bigolive.png": 8992,
	"./sources-logo-display.png": 5982,
	"./sources-logo-huawei.png": 756,
	"./sources-logo-ironsource.png": 7603,
	"./sources-logo-liftoff.png": 3576,
	"./sources-logo-moloco.png": 5592,
	"./sources-logo-mytarget.png": 7169,
	"./sources-logo-shareit.png": 4020,
	"./sources-logo-telegram.png": 7420,
	"./sources-logo-tiktok.png": 1435,
	"./sources-logo-vk.png": 5315,
	"./sources-logo-xiaomi.png": 3192,
	"./sources-logo-yandex.png": 7212,
	"./sourse-logo-mintegral.png": 2313,
	"./waw.png": 6956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;